<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <span class="mr-4">
          {{ $t('ITEM.CREATE') }}
          {{ (blockTypeById(blockType.id) || {}).name }}
        </span>
        <v-spacer></v-spacer>

        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle v-if="errorsWithoutForm.length">
        <errors :errors="errorsWithoutForm" />
      </v-card-subtitle>
      <v-card-text>
        <block-form
          v-model="form"
          :resource="resource"
          :block-type="blockType"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" :disabled="!valid" @click="create">
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import Errors from '@/modules/_global/_components/Errors';
import BlockForm from '../forms/BlockForm';
import { BlocksService } from '@/services/reservations/blocks.service';
import blockTypes from '@/modules/booking_schedule/mixins/block-types';
import { HOUR } from '@/modules/booking_schedule/common/block_types';

export default {
  name: 'CreateBlock',

  components: {
    Errors,
    BlockForm
  },

  mixins: [errors, blockTypes],

  props: {
    resource: {
      type: Object,
      required: true
    },
    blockType: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: false,
      form: {},
      hour: HOUR
    };
  },

  computed: {
    errorsWithoutForm() {
      return ['resource_id', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  mounted() {},

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    create() {
      const form = {
        ...this.form,
        resource_id: this.resource.id,
        resource_type: this.blockType.id
      };
      BlocksService.create(form)
        .then(response => {
          this.$emit('created', response.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
